/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-dialog[_ngcontent-%COMP%]{width:1200px}textarea[_ngcontent-%COMP%]{resize:vertical}.pesticide-value[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-planning-modal/request-planning-modal.component.css.shim.ngstyle.js.pre-build-optimizer.js